import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import useIsKioskUser from "@/shared/hooks/useIsKioskUser";
import { useQuery } from "@tanstack/react-query";
import { CourierGeoLocation } from "./interfacesV2";

const useLatestCouriersLocations = () => {
  const branch = useBranchId();
  // A kiosk has no couriers to show
  const isKioskUser = useIsKioskUser();

  const query = useQuery<CourierGeoLocation[]>({
    queryKey: ["latest", "couriers", branch],
    queryFn: () =>
      get2(`/internal/secure/pos/v1/couriers/latest/geo/locations/${branch}`),

    refetchInterval: 60000,
    enabled: branch > 0 && !isKioskUser,
  });
  return query;
};

export default useLatestCouriersLocations;
